module.exports = __webpack_public_path__ + "img/img15.6c78fd8b.jpg";